<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="page_vi"></a><em class="italic">There are two voices in this book, mine and my grandfather’s, William McCrae. William’s writing is at the heart of this account, and all his words are therefore in a contrasting font, in order that the reader can easily differentiate his narrative from my own. SB</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Ded1.vue?370d7fa1